<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <template class="header">
          <h4 class="card-title style-title">New Pickup Point</h4>
          <h5 class="description style-title">
            Please fill in all the required details to add new Pickup Point.
          </h5>
        </template>
      </div>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <card>
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <h4 class="card-title style-title">Pickup Details</h4>
            </div>
          </div>
          <div class="row justify-content-center">
            <!-- Select Site/Route, PickupPoint Name and Lat/Long -->
            <div class="col-lg-2">
              <base-input label="1. Region">
                <el-select
                  class="select-danger"
                  placeholder="Region"
                  v-model="selects.selectRegion"
                  @change="getRoute(selects.selectRegion)"
                >
                  <el-option
                    v-for="item in selects.regions"
                    class="select-danger"
                    :value="item.value"
                    :label="item.label"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </base-input>
              <base-input label="2. Select Site / Route">
                <el-select
                  class="select-danger"
                  placeholder="Site/Route"
                  v-model="selects.selectRoute"
                >
                  <el-option
                    v-for="item in selects.routes"
                    class="select-danger"
                    :value="item.value"
                    :label="item.label"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </base-input>
              <base-input
                label="3. Pickup Point Name"
                placeholder="Pickup Point"
                v-model="pickupPoint"
              ></base-input>
              <base-input
                label="4. Latitude"
                placeholder="Latitude"
                type="number"
                v-model="lat"
              ></base-input>
              <base-input
                label="5. Longitude"
                placeholder="Longitude"
                type="number"
                v-model="long"
              ></base-input>
              <base-input
                label="6. Radius (in meter)"
                placeholder="Radius"
                type="number"
                v-model="radius"
              ></base-input>
              <base-input label="7. Landside or Airside">
                <el-select class="select-danger" v-model="selects.selectSite">
                  <el-option
                    v-for="item in selects.site"
                    class="select-danger"
                    :value="item.value"
                    :label="item.label"
                    :key="item.value"
                  ></el-option>
                </el-select>
              </base-input>
            </div>

            <!-- Frequecy of Pickup -->
            <div class="col-lg-4" style="margin-left: 2%">
              <div class="row">
                <div class="col-lg-12 text-center">
                  <label style="font-size: 16px">8. Frequency of pickup</label>
                </div>
                <div class="row ml-auto mr-auto group-form">
                  <div class="col-lg-6">
                    <div class="row">
                      <label class="col-md-5 col-form-label">MON:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="monday"
                          >
                            <el-option
                              v-for="c in selects.totalPickup"
                              class="select-danger"
                              :value="c.value"
                              :label="c.label"
                              :key="c.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                      <label class="col-md-5 col-form-label">TUE:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="tuesday"
                          >
                            <el-option
                              v-for="d in selects.totalPickup"
                              class="select-danger"
                              :value="d.value"
                              :label="d.label"
                              :key="d.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                      <label class="col-md-5 col-form-label">WED:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="wednesday"
                          >
                            <el-option
                              v-for="e in selects.totalPickup"
                              class="select-danger"
                              :value="e.value"
                              :label="e.label"
                              :key="e.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                      <label class="col-md-5 col-form-label">THU:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="thursday"
                          >
                            <el-option
                              v-for="f in selects.totalPickup"
                              class="select-danger"
                              :value="f.value"
                              :label="f.label"
                              :key="f.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row">
                      <label class="col-md-5 col-form-label">FRI:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="friday"
                          >
                            <el-option
                              v-for="g in selects.totalPickup"
                              class="select-danger"
                              :value="g.value"
                              :label="g.label"
                              :key="g.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-5 col-form-label">SAT:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="saturday"
                          >
                            <el-option
                              v-for="h in selects.totalPickup"
                              class="select-danger"
                              :value="h.value"
                              :label="h.label"
                              :key="h.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-5 col-form-label">SUN:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="sunday"
                          >
                            <el-option
                              v-for="i in selects.totalPickup"
                              class="select-danger"
                              :value="i.value"
                              :label="i.label"
                              :key="i.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Type of Bin -->
            <div class="col-lg-5" style="margin-left: 2%">
              <div class="row">
                <div class="col-lg-12 text-center">
                  <label style="font-size: 16px">9. Type of Bin</label>
                </div>
                <form>
                  <div class="row ml-auto mr-auto group-form">
                    <div class="col-lg">
                      <div class="row" v-for="bin in bins1" :key="bin.key">
                        <label class="col-md-6 col-form-label">{{
                          bin.key
                        }}</label>
                        <div class="col-lg-6">
                          <base-input
                            class="danger"
                            placeholder="Bin"
                            v-model="bin.value"
                            type="number"
                          ></base-input>
                        </div>
                      </div>
                    </div>
                    <!-- <div class="col-lg-6">
                      <div class="row" v-for="bin in bins2" :key="bin.key">
                        <label class="col-md-6 col-form-label">{{
                          bin.key
                        }}</label>
                        <div class="col-lg-6">
                          <base-input
                            class="danger"
                            placeholder="Bin"
                            v-model="bin.value"
                            type="number"
                          ></base-input>
                        </div>
                      </div>
                    </div> -->
                  </div>
                </form>
              </div>
            </div>

            <div class="col-lg-12 text-center">
              <el-link
                href="./img/csv/PickupPointRegistration.csv"
                class="mt-3"
                type="primary"
                >Download CSV template</el-link
              >
              &nbsp;
              <span
                class="btn btn-success btn-file btn-simple"
                style="margin-bottom: 0%; margin-top: 0.7%"
              >
                <span class="fileinput-new">Import with CSV</span>
                <input
                  accept=".csv"
                  type="file"
                  class="valid"
                  :multiple="false"
                  @change="importCsv"
                />
              </span>
              &nbsp;
              <base-button class="mt-3" @click="addPickup()" type="primary"
                >Add Schedule</base-button
              >
            </div>
          </div>
          <div class="col-sm-12">
            <hr />
          </div>
          <div class="col-sm-12 text-center" style="margin-top: 2%">
            <h3>Schedule Details</h3>
          </div>
          <div class="col-sm-12">
            <el-table
              :data="tableData"
              style="border: solid white; border-radius: 10px"
              :header-cell-style="{
                background: 'transparent',
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
              :cell-style="{
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
            >
              <el-table-column
                min-width="120"
                sortable
                align="center"
                label="Region"
                property="region"
              ></el-table-column>
              <el-table-column
                min-width="120"
                sortable
                align="center"
                label="Route"
                property="route"
              ></el-table-column>
              <el-table-column
                min-width="120"
                sortable
                align="center"
                label="Pickup Point"
                property="pickupPoint"
              ></el-table-column>
              <el-table-column
                min-width="120"
                sortable
                align="center"
                label="Latitude"
                property="latitude"
              ></el-table-column>
              <el-table-column
                min-width="120"
                sortable
                align="center"
                label="Longitude"
                property="longitude"
              ></el-table-column>
              <el-table-column
                min-width="120"
                sortable
                align="center"
                label="Total Pickup"
                property="totalPickup"
              ></el-table-column>
              <el-table-column
                min-width="100"
                sortable
                align="center"
                label="Total Bins"
                property="totalBins"
              ></el-table-column>
              <el-table-column :min-width="45" align="right">
                <div slot-scope="props">
                  <el-tooltip
                    content="Delete"
                    placement="bottom"
                    effect="light"
                  >
                    <base-button
                      @click.native="handleDelete(props.$index, props.row)"
                      class="remove btn-link"
                      type="danger"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-lg-12 text-center">
            <base-button type="primary" @click="submitData()"
              >Submit</base-button
            >&nbsp;
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
import { Table, TableColumn, Link } from "element-ui";
import swal from "sweetalert2";
import { Modal } from "src/components";
import { ImageUpload } from "src/components/index";

export default {
  components: {
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    [Link.name]: Link,
  },
  data() {
    return {
      // Storing registered bins
      bins1: [],
      bins2: [],
      custID: "",
      password: "",
      address: "",
      phoneNo: "",
      email: "",
      pic: "",
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday: 0,
      saturday: 0,
      sunday: 0,
      pickupPoint: "",
      lat: "",
      long: "",
      radius: "0",
      label: [],
      fileName: "",
      items: {
        labels: [],
      },
      selects: {
        selectRoute: "",
        selectRegion: "",
        selectSite: "",
        totalPickup: [
          { value: "0", label: "0" },
          { value: "1", label: "1" },
          { value: "2", label: "2" },
          { value: "3", label: "3" },
          { value: "4", label: "4" },
          { value: "5", label: "5" },
        ],
        site: [
          { value: "1", label: "Airside" },
          { value: "2", label: "Landside" },
        ],
        regions: [],
        routes: [],
      },
      pickup: true,
      // Table
      tableData: [],
      sendData: [],
      csvValue: "No file selected",
      modals: {
        upload: false,
      },
      csvdata: [],
      submitPayload: [],
      allRoute: [],
    };
  },
  created() {
    this.custID = this.$route.params.custid;
    this.getRegion();
    this.getBinType();
    this.getAllRoute();
  },
  methods: {
    getBinType() {
      this.$http.get(":9991/api/v1/setting/bin").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          // let x = Math.ceil(response.length / 2);
          // for (let i = 0; i < x; i++) {
          for (let i = 0; i < response.length; i++) {
            let bin = {};
            bin["key"] = response[i].binname;
            bin["bintypeid"] = response[i].BintypeID;
            bin["value"] = window["Object" + i];
            this.bins1.push(bin);
          }

          console.log(this.bins1);
          // for (let i = x; i <= response.length; i++) {
          //   console.log(response[i])
          //   let bin = {};
          //   bin["key"] = response[i].binname;
          //   bin["bintypeid"] = response[i].BintypeID;
          //   bin["value"] = window["Object" + i];
          //   this.bins2.push(bin);
          // }

          // console.log(this.bins2)
        } else {
          swal({
            title: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
    getRegion() {
      this.$http.get(":9991/api/v1/customers/region").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let data = {
              label: response[i].RegionName,
              value: response[i].RegionID,
            };
            this.selects.regions.push(data);
          }
        } else {
          swal({
            title: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
      this.region = [];
    },
    getRoute(regionID) {
      this.$http
        .post(":9991/api/v1/customers/routeList/" + regionID)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            for (var i = 0; i < response.length; i++) {
              let data = {
                label: response[i].RouteName,
                value: response[i].RouteID,
              };
              this.selects.routes.push(data);
            }
          } else {
            swal({
              title: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
    },
    getAllRoute() {
      this.$http.get(":9991/api/v1/customers/route").then((res) => {
        if (!res.error) {
          let response = res.message;
          this.allRoute = response;
        } else {
          swal({
            title: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
    addPickup() {
      if (
        this.selects.selectRegion === "" ||
        this.selects.selectRoute === "" ||
        this.pickupPoint === "" ||
        this.lat === "" ||
        this.long === "" ||
        this.monday === "" ||
        this.tuesday === "" ||
        this.wednesday === "" ||
        this.thursday === "" ||
        this.friday === "" ||
        this.saturday === "" ||
        this.sunday === ""
      ) {
        swal({
          title: "Form is incomplete!",
          text: "PLease fill in all details to add a pickip",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      } else {
        // GET VALUE OF REGION AND ROUTE
        let REGION;
        let ROUTE;

        for (let i = 0; i < this.selects.regions.length; i++) {
          if (this.selects.selectRegion == this.selects.regions[i].value) {
            REGION = this.selects.regions[i].label;
          }
        }

        for (let i = 0; i < this.selects.routes.length; i++) {
          if (this.selects.selectRoute == this.selects.routes[i].value) {
            ROUTE = this.selects.routes[i].label;
          }
        }

        // CONVERT PICKUP FREQ INTO ARRAY
        let pickupFrequency = [
          parseInt(this.monday),
          parseInt(this.tuesday),
          parseInt(this.wednesday),
          parseInt(this.thursday),
          parseInt(this.friday),
          parseInt(this.saturday),
          parseInt(this.sunday),
        ];

        // CREATE ARRAY OF LIST OF BINS
        let binList = [];

        for (let i = 0; i < this.bins1.length; i++) {
          if (this.bins1[i].value != null) {
            for (let j = 0; j < this.bins1[i].value; j++) {
              binList.push(this.bins1[i].bintypeid);
            }
          }
        }

        // for (let i = 0; i < this.bins2.length; i++) {
        //   if (this.bins2[i].value != null) {
        //     for (let j = 0; j < this.bins2[i].value; j++) {
        //       binList.push(this.bins2[i].bintypeid);
        //     }
        //   }
        // }

        // CREATE PAYLOAD TO ADD PICKUP
        let payload = {
          custid: this.custID,
          regionid: this.selects.selectRegion,
          routeid: this.selects.selectRoute,
          pickupname: this.pickupPoint,
          PickupFreq: pickupFrequency,
          pickuplat: parseFloat(this.lat),
          pickuplong: parseFloat(this.long),
          pickupradius: this.radius.toString(),
          ppstatid: this.selects.selectSite,
          binlist: binList,
          radius: this.radius.toString(),
        };

        this.submitPayload.push(payload);

        // ADD PICKUP TO TABLE FOR REVIEW
        let total = 0;
        for (var i = 0; i < pickupFrequency.length; i++) {
          total += pickupFrequency[i];
        }

        let pickupPointTable = {
          route: ROUTE,
          region: REGION,
          pickupPoint: this.pickupPoint,
          totalPickup: total,
          latitude: parseFloat(this.lat),
          longitude: parseFloat(this.long),
          totalBins: binList.length,
        };
        this.tableData.push(pickupPointTable);

        // CLEAR FORM
        this.selects.selectRoute = "";
        this.selects.selectRegion = "";
        this.pickupPoint = "";
        this.lat = "";
        this.long = "";
        this.radius = "";
        this.monday = 0;
        this.tuesday = 0;
        this.wednesday = 0;
        this.thursday = 0;
        this.friday = 0;
        this.saturday = 0;
        this.sunday = 0;

        for (let i = 0; i < this.bins1.length; i++) {
          this.bins1[i].value = undefined;
        }

        // for (let i = 0; i < this.bins2.length; i++) {
        //   this.bins2[i].value = undefined;
        // }
      }
    },
    handleDelete(index, row) {
      this.tableData.pop(index);
      this.sendData.pop(index);
    },
    importCsv(data) {
      const file = data.target.files[0];
      const reader = new FileReader();
      reader.readAsText(file);

      reader.onload = (e) => {
        let header;
        let lines = [];
        let csv = e.target.result; // Content from file
        let allTextLines = csv.split(/\r\n|\n/);
        for (let i = 0; i < allTextLines.length; i++) {
          if (i == 0) {
            header = allTextLines[i].split(",");
          } else {
            lines.push(allTextLines[i].split(","));
          }
        }

        // REMOVE CSV HEADER
        lines.pop();

        lines.forEach((line) => {
          console.log(line);

          let REGION;
          let ROUTE;
          let isRegion = false;
          let isRoute = false;

          // CHECK IF REGION IN CSV EXIST IN DATABASE
          console.log(this.selects.regions)
          for (let i = 0; i < this.selects.regions.length; i++) {
            console.log(line[1].toString());
            if (line[1] == this.selects.regions[i].label) {
              console.log("samaa");
              REGION = this.selects.regions[i].value;
              isRegion = true;
            }
          }

          console.log(isRegion);

          for (let i = 0; i < this.allRoute.length; i++) {
            if (line[0] == this.allRoute[i].RouteName) {
              ROUTE = this.allRoute[i].RouteID;
              isRoute = true;
            }
          }

          if (!isRegion) {
            swal({
              title: `${line[1]} in CSV does not exist!`,
              text: `Please contact admin to add new region!`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.submitPayload = [];
            return;
          }

          if (!isRoute) {
            swal({
              title: `${line[0]} in CSV does not exist!`,
              text: `Please contact admin to add new route!`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.submitPayload = [];

            return;
          }

          console.log(REGION, ROUTE);

          // CONVERT PICKUP FREQ INTO ARRAY
          let pickupFrequency = [
            parseInt(line[3]),
            parseInt(line[4]),
            parseInt(line[5]),
            parseInt(line[6]),
            parseInt(line[7]),
            parseInt(line[8]),
            parseInt(line[9]),
          ];

          // GET BIN ID
          let binList = [];
          let csvBin = line[14].split(";");
          // let dbBin = this.bins1.concat(this.bins2);
          let dbBin = this.bins1

          for (let i = 0; i < csvBin.length; i++) {
            for (let j = 0; j < dbBin.length; j++) {
              if (csvBin[i] == dbBin[j].key) {
                binList.push(dbBin[j].bintypeid);
              }
            }
          }

          // CREATE PAYLOAD TO ADD PICKUP
          let payload = {
            custid: this.custID,
            regionid: REGION,
            routeid: ROUTE,
            pickupname: line[2],
            PickupFreq: pickupFrequency,
            pickuplat: parseFloat(line[10]),
            pickuplong: parseFloat(line[11]),
            pickupradius: line[12],
            ppstatid: line[13],
            binlist: binList,
          };

          this.submitPayload.push(payload);

          // ADD PICKUP TO TABLE FOR REVIEW
          let total = 0;
          for (var i = 0; i < pickupFrequency.length; i++) {
            total += pickupFrequency[i];
          }

          let pickupPointTable = {
            route: line[0],
            region: line[1],
            pickupPoint: line[2],
            totalPickup: total,
            latitude: parseFloat(line[10]),
            longitude: parseFloat(line[11]),
            totalBins: line[14].split(";").length,
          };
          this.tableData.push(pickupPointTable);
        });
      };
    },
    submitData() {
      if (this.submitPayload.length != 0) {
        // Submit
        console.log(this.submitPayload);

        this.$http
          .post(":9991/api/v1/customers/addpickup", this.submitPayload)
          .then((res) => {
            if (!res.error) {
              swal({
                title: "Success!",
                text: res.message,
                type: "Success",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay!",
                buttonsStyling: false,
              }).then((result) => {
                if (result.value) {
                  this.$router.push({
                    path: `/Greencard/PickupPointUpdate/${this.custID}`,
                  });
                }
              });
            } else {
              swal({
                text: res.message,
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
            }
          });
      } else {
        swal({
          title: "No schedule added!",
          text: `Please add a schedule details to continue!`,
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      }
    },
  },
};
</script>

<style scoped>
.style-title {
  text-align: center;
}
</style>
